import type { ReactNode } from 'react';
import { cn } from './cn';

interface PageShellProps {
  children: ReactNode;
  className?: string;
}

export const PageShell = ({ children, className }: PageShellProps) => (
  <div className="px-5 md:px-10 xl:px-16 2xl:px-20">
    <div className={cn('container min-h-screen mx-auto pb-16', className)}>{children}</div>
  </div>
);
